import devWarning from "rc-util/es/warning";
export function lintWarning(message, info) {
  var path = info.path,
    parentSelectors = info.parentSelectors;
  devWarning(false, "[Ant Design CSS-in-JS] ".concat(path ? "Error in ".concat(path, ": ") : '').concat(message).concat(parentSelectors.length ? " Selector: ".concat(parentSelectors.join(' | ')) : ''));
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/@ant-design/cssinjs/es/linters/utils.js
// module id = 264
// module chunks = 0